export function PageLoader({ label = "Loading" }: { label?: string }) {
  return (
    <div
      className="flex min-h-screen flex-col items-center justify-center gap-5 bg-ink text-paper"
      role="status"
      aria-live="polite"
    >
      <span className="block size-6 rotate-45 animate-pulse bg-accent" />
      <span className="font-mono text-xs tracking-[0.3em] uppercase">{label}</span>
    </div>
  );
}

/** Inline error panel. Replaces the 2020 `bulma-toast` popups, which vanished. */
export function ErrorNotice({ error, retry }: { error: unknown; retry?: () => void }) {
  const message = error instanceof Error ? error.message : "Something went wrong.";

  return (
    <div className="notice-error" role="alert">
      <p className="font-medium">{message}</p>
      {retry && (
        <button type="button" className="btn-danger btn-sm mt-3" onClick={retry}>
          Try again
        </button>
      )}
    </div>
  );
}

/** On/off switch. Square, to match everything else. */
export function Toggle({
  id,
  checked,
  onChange,
  label,
}: {
  id: string;
  checked: boolean;
  onChange: (next: boolean) => void;
  label: string;
}) {
  return (
    <label htmlFor={id} className="group inline-flex cursor-pointer items-center gap-3 select-none">
      <input
        id={id}
        type="checkbox"
        role="switch"
        className="sr-only"
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
      />
      {/* `group-has-[:checked]` rather than `peer-checked` — the knob is a
          descendant of the track, and peer variants only match siblings. */}
      <span className="relative h-6 w-11 border-2 border-ink bg-paper transition-colors group-has-checked:bg-accent">
        <span className="absolute top-0.5 left-0.5 size-4 bg-ink transition-transform group-has-checked:translate-x-5" />
      </span>
      <span className="font-mono text-xs tracking-[0.15em] uppercase">{label}</span>
    </label>
  );
}
